module.exports = __webpack_public_path__ + "static/img/news.f3630792.png";